import { Snowflake, Compass, Flame, MapPin, Mountain } from "lucide-react";

const scenarios = [
  {
    icon: Snowflake,
    when: "When you freeze",
    then: "Mindrail gives you a restart pathway.",
    accent: "#7C3AED",
  },
  {
    icon: Compass,
    when: "When you drift",
    then: "It catches the pattern and nudges gently.",
    accent: "#F59E0B",
  },
  {
    icon: Flame,
    when: "When you overfocus",
    then: "It reminds you before the session becomes costly.",
    accent: "#F9735B",
  },
  {
    icon: MapPin,
    when: "When you lose context",
    then: "It helps you resume where you left off.",
    accent: "#22C55E",
  },
  {
    icon: Mountain,
    when: "When everything feels too big",
    then: "It helps you find just one thing.",
    accent: "#22C55E",
  },
];

export default function Scenarios() {
  return (
    <section
      data-testid="scenarios-section"
      className="px-6 lg:px-10 py-24 lg:py-32"
    >
      <div className="max-w-6xl mx-auto">
        <div className="fade-up max-w-3xl">
          <p className="text-sm tracking-[0.18em] uppercase font-semibold text-[#475569]">
            Scenario proof
          </p>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium leading-[1.05]">
            Built for the moments other tools ignore.
          </h2>
        </div>

        <div className="mt-14 divide-y divide-[#E2E8F0] border-t border-b border-[#E2E8F0]">
          {scenarios.map((s, i) => (
            <div
              key={i}
              data-testid={`scenario-${i}`}
              className="fade-up py-7 grid grid-cols-1 md:grid-cols-12 gap-5 md:gap-8 items-center group"
            >
              <div className="md:col-span-1 flex md:justify-center">
                <span
                  className="w-10 h-10 rounded-xl flex items-center justify-center"
                  style={{ background: s.accent + "1f" }}
                >
                  <s.icon
                    className="w-4 h-4"
                    strokeWidth={1.5}
                    style={{ color: s.accent }}
                  />
                </span>
              </div>
              <p className="md:col-span-4 font-display text-xl text-[#0F172A] tracking-tight">
                {s.when}
              </p>
              <p className="md:col-span-7 text-[#475569] text-base flex items-center gap-3">
                <span
                  className="hidden md:inline-block h-px w-8"
                  style={{ background: s.accent }}
                />
                <span className="text-[#0F172A]">{s.then}</span>
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
